import Home from "./Home/Home";
import SafetyDocument from "./SafetyDocument/SafetyDocument";
import ContactUserLogin from "./ContactUserLogin/ContactUserLogin";
import CommonLogin from "./CommonLogin/CommonLogin";
import UnAuthorized from "./UnAuthorized/UnAuthorized";
import Profile from "./Profile/Profile";
import Support from "./Support/Support";
import SitesReport from "./SitesReport/SitesReport";
import SafetyDocumentReport from "./SafetyDocumentReport/SafetyDocumentReport";
import RemindersDueToday from "./RemindersDueToday/RemindersDueToday";
import PageNotFound from "./PageNotFound/PageNotFound";
import RuleBuilder from "./RuleBuilder/RuleBuilder";
import ContactsReport from "./ContactsReport/ContactsReport";
import RuleRepository from "./RuleRepository/RuleRepository";
import ConsolidatedReport from "./ConsolidatedReport/ConsolidatedReport";
import AllNotifiactions from "./AllNotifications/AllNotifiactions";
import ViewSafetyDocument from "./ViewSafetyDocument/ViewSafetyDocument";
import Notification from "./Notification/Notification";
import SystemLogs from './SystemLogs/SystemLogs';
import Search from './Search/Search';

export {
  Home,
  SafetyDocument,
  ViewSafetyDocument,
  AllNotifiactions,
  Notification,
  ContactUserLogin,
  CommonLogin,
  UnAuthorized,
  Profile,
  Support,
  SitesReport,
  SafetyDocumentReport,
  RemindersDueToday,
  PageNotFound,
  RuleBuilder,
  ContactsReport,
  RuleRepository,
  ConsolidatedReport,
  SystemLogs,
  Search
};
